import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNotFoundUrl } from '../../selectors/notFoundUrl';
import { EmptyPage } from '../../components/EmptyPage';
import { trackNavigationToFlats } from './tracking';

export const EmptyPageContainer: React.FC<{}> = () => {
  const notFoundUrl = useSelector(selectNotFoundUrl);

  const handleClick = React.useCallback(() => {
    trackNavigationToFlats();
  }, []);

  return <EmptyPage notFoundUrl={notFoundUrl} onNotFoundUrlClick={handleClick} />;
};
